import React from 'react';

const Contact = () => {
  return (
    <div className="pt-20 min-h-screen bg-linen-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-display text-4xl font-semibold text-walnut-800 mb-8">Contact Us</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-walnut-600">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="mt-1 block w-full rounded-md border-linen-200 shadow-xs focus:border-copper-500 focus:ring-copper-500"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-walnut-600">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="mt-1 block w-full rounded-md border-linen-200 shadow-xs focus:border-copper-500 focus:ring-copper-500"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-walnut-600">
                  Message
                </label>
                <textarea
                  id="message"
                  rows={4}
                  className="mt-1 block w-full rounded-md border-linen-200 shadow-xs focus:border-copper-500 focus:ring-copper-500"
                />
              </div>
              <button
                type="submit"
                className="bg-copper-500 text-linen-50 px-6 py-2 rounded-lg hover:bg-copper-600 transition-colors"
              >
                Send Message
              </button>
            </form>
          </div>
          <div>
            <h2 className="font-display text-2xl font-semibold text-walnut-800 mb-4">Get in Touch</h2>
            <div className="space-y-4">
              <p className="text-walnut-600">
                <strong>Email:</strong> john@treetotablespokane.com
              </p>
              <p className="text-walnut-600">
                <strong>Phone:</strong> (509) 990-1886
              </p>
              <p className="text-walnut-600">
                <strong>Location:</strong> Spokane, WA
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;